// extracted by mini-css-extract-plugin
export default {"chartType":"ChartType_chartType__jnuMt"};